import { useContext } from "react";
import PropTypes from "prop-types";
import { UserContext } from "../../../pages/UserContext";
import isTokenValid from "../../../utlities/auth.utility";

/**
 * Route gate for ACR Editor routes.
 * The editor is open to everyone. Authenticated vendor/agency/super users get the full experience;
 * anonymous or unauthorized users get "Public Mode" (autosave and submit disabled, download still
 * allowed), enforced by the per-page checks that key off useEditorAccess. This gate waits until the
 * session is settled before the editor decides which mode to show. A token without a loaded user
 * (the login callback stores the token before AppShell finishes loading the user, and the storage
 * check may already be true from the earlier anonymous read) is still restoring — opening Public
 * Mode in that window rewrites the draft.
 */
export default function ProtectedEditorRoute({ children }) {
  const { token, user, initialUserStorageCheck, initialUserCallbackCheck } = useContext(UserContext);
  const isInitialized = initialUserStorageCheck && initialUserCallbackCheck;
  const sessionRestoring = isTokenValid(token) && !user;

  if (!isInitialized || sessionRestoring) {
    return null;
  }

  return children;
}

ProtectedEditorRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
